import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    marginTop: '10px',
  },
}));

export default useStyles;
